import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://cmlatrinite-matadi.com';
const DEFAULT_IMAGE = `${SITE_URL}/photos/facade_principale.jpg`;

/**
 * Per-page SEO tags. Wrap each public page top-level to override
 * the defaults set in public/index.html.
 */
export default function PageSEO({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  article,
}) {
  const fullTitle = title
    ? `${title} | Centre Médical la Trinité`
    : 'Centre Médical la Trinité | Rendez-vous en ligne à Matadi & Boma (RDC)';
  const canonical = `${SITE_URL}${path}`;
  const desc =
    description ||
    "Centre Médical La Trinité — cabinet médical à Matadi & Boma (RDC). Consultations, téléconsultation, chirurgie, gynécologie, pédiatrie. Rendez-vous en ligne 24h/24.";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />

      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'MedicalWebPage',
            headline: article.title,
            image: article.image || image,
            datePublished: article.published_at,
            dateModified: article.updated_at || article.published_at,
            author: {
              '@type': 'Person',
              name: article.author || 'Centre Médical la Trinité',
            },
            publisher: {
              '@type': 'MedicalOrganization',
              name: 'Centre Médical la Trinité SARLU',
              logo: {
                '@type': 'ImageObject',
                url: `${SITE_URL}/cmt_logo.png`,
              },
            },
            mainEntityOfPage: canonical,
          })}
        </script>
      )}
    </Helmet>
  );
}
